import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState({
    minutes: 14,
    seconds: 59
  });
  const [isVisible, setIsVisible] = useState(true);
  const [isExpired, setIsExpired] = useState(false);
  useEffect(() => {
    const DURATION = 15 * 60 * 1000;
    let targetTime = localStorage.getItem('huerta_urgency_target');
    if (!targetTime) {
      targetTime = (Date.now() + DURATION).toString();
      localStorage.setItem('huerta_urgency_target', targetTime);
    }
    const calculateTimeLeft = () => {
      const now = Date.now();
      const difference = parseInt(targetTime!) - now;
      if (difference <= 0) {
        setIsExpired(true);
        return {
          minutes: 0,
          seconds: 0
        };
      }
      return {
        minutes: Math.floor(difference / 1000 / 60 % 60),
        seconds: Math.floor(difference / 1000 % 60)
      };
    };
    setTimeLeft(calculateTimeLeft());
    const timer = setInterval(() => {
      const newTimeLeft = calculateTimeLeft();
      setTimeLeft(newTimeLeft);
      if (newTimeLeft.minutes === 0 && newTimeLeft.seconds === 0) {
        clearInterval(timer);
      }
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed top-0 left-0 w-full z-50 bg-zinc-900/95 border-b border-green-500/30 py-1.5 px-3 shadow-lg backdrop-blur-sm" data-id="element-249">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-center" data-id="element-250">
        <span className="relative flex h-2 w-2 flex-shrink-0" data-id="element-251">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-red-500 opacity-75" data-id="element-252"></span>
          <span className="relative inline-flex rounded-full h-2 w-2 bg-red-600" data-id="element-253"></span>
        </span>
        <p className="text-xs font-bold text-white" data-id="element-254">
          {isExpired ? <span className="text-red-500" data-id="element-255">⚠ ÚLTIMAS UNIDADES</span> : <>
              OFERTA LIMITADA:{' '}
              <span className="text-green-500" data-id="element-256">7 cupos con bonus</span>
            </>}
        </p>
        {!isExpired && <div className="flex items-center gap-1 bg-black/30 px-2 py-0.5 rounded border border-white/10" data-id="element-257">
            <Clock className="w-3 h-3 text-green-500" data-id="element-258" />
            <span className="text-xs font-mono font-bold text-white" data-id="element-259">
              00:{timeLeft.minutes.toString().padStart(2, '0')}:
              {timeLeft.seconds.toString().padStart(2, '0')}
            </span>
          </div>}
      </div>
    </div>;
}